import { render, staticRenderFns } from "./CircleImg.vue?vue&type=template&id=0d8f53e1"
import script from "./CircleImg.vue?vue&type=script&lang=js"
export * from "./CircleImg.vue?vue&type=script&lang=js"
import style0 from "./CircleImg.vue?vue&type=style&index=0&id=0d8f53e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports